export default __webpack_public_path__ + "static/media/rocket.590a702c.png";